import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { currentUrl: String }
  static targets = ["button"]

  toggle(event) {
    const url = event.target.value
    this.buttonTarget.disabled = !url || url === this.currentUrlValue
  }
}
